import(/* webpackMode: "eager" */ "/opt/buildhome/repo/landing/node_modules/next/dist/client/script.js");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/landing/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Geist\",\"arguments\":[{\"variable\":\"--font-geist-sans\",\"subsets\":[\"latin\"]}],\"variableName\":\"geistSans\"}");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/landing/node_modules/next/font/google/target.css?{\"path\":\"src/app/layout.js\",\"import\":\"Geist_Mono\",\"arguments\":[{\"variable\":\"--font-geist-mono\",\"subsets\":[\"latin\"],\"preload\":false}],\"variableName\":\"geistMono\"}");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/landing/src/app/components/AnalyticsEvents.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/landing/src/app/components/MetaPixelEvents.jsx");
;
import(/* webpackMode: "eager", webpackExports: ["default"] */ "/opt/buildhome/repo/landing/src/app/components/RedditPixelEvents.jsx");
;
import(/* webpackMode: "eager" */ "/opt/buildhome/repo/landing/src/app/globals.css");
